import { useRef } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Page from './components/Page';

function App() {
  const refAbout = useRef(null);
  const refProjects = useRef(null);
  const refSkills = useRef(null);
  const refEducation = useRef(null);
  const refExperience = useRef(null);
  const refContact = useRef(null);
  return (
    <div style={{margin:0}}>
      <Navbar refs={{ refAbout, refProjects, refSkills, refEducation, refExperience, refContact }} />
      <Page refs={{ refAbout, refProjects, refSkills, refEducation, refExperience, refContact }} />
    </div>
  );
}

export default App;
